module.exports = __webpack_public_path__ + "static/img/nodata-robot.70e91ba0.png";